import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from 'config';
import HomeApiCall from 'HomeApiCall';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import React, { Component } from 'react';
import 'Home/Components/LatestUpdates/latestupdates.css';
import ButtonLoader from 'Home/CommonResources/ButtonLoader/ButtonLoader';
import SuccessModal from 'Home/CommonResources/SuccessModal/SuccessModal';
import Pagination from 'react-js-pagination';
import ReactHtmlParser from 'react-html-parser';
import moment from 'moment';

class LatestUpdates extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fetchingAssistanceDetails: false,
            showRecentUpdateModel:this.props.showRecentUpdateModel,
            helpDeskAssistance: '',
            telephonicAssistance: '',
            emailAssistance: '',
            onlineDemo: '',
            onlineAssistance: '',

            // VARIABLES FOR SUCCESS MODAL
            moduleWaring:'',

            // VARIABLES TO VIEW DETAILS
            viewAssistanceDetails: false,
            currentActiveTab: '',

            //variables for recent update
            showRecentUpdate:false,
            fetchingRecentUpdate:false,
            limit: 25,           
            offset: 0,
            page_index:1,
            activePage: 1,
            module_name:[],
            assistance_type:'Daily Updates',
            RecentUpdateList:[],
            filterDisplay:false,
            totalItemsCount:{},
        };
    }

    componentDidMount() {
        // METHOD CALLED TO GET ASSISTANCE COUNT
        this.apiCallToGetAssistanceDetails();
        
        // if(this.state.showRecentUpdateModel && document.referrer.includes("public/auth/"))
        // {
        //     this.setState({showRecentUpdate:true},()=> this.apiCallToGetRecentUpdate())
        // }
    }

    

    // API CALL METHOD TO GET ASSISTANCE DETAILS
    apiCallToGetAssistanceDetails = async () => {
        this.setState({
            fetchingAssistanceDetails: true
        });

        let requestData = {
            'iid': config.institute_id
        };

        let jsonResponse = await HomeApiCall.makeApiCall(
            'getHelpDeskCount',
            requestData,
            '/api/helpDesk/helpDesk.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAssistanceDetails();
            }, 1000);
        }else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                
                this.setState({
                    fetchingAssistanceDetails: false,
                    helpDeskAssistance: apiResult['Helpdesk Assistance'],
                    telephonicAssistance: apiResult['Telephonic Assistance'],
                    emailAssistance: apiResult['Email Assistance'],
                    onlineDemo: apiResult['Online Demonstration'],
                    onlineAssistance: apiResult['Online Assistance'],
                });
            }
        }
    }

    

    // API CALL METHOD TO GET RECENT UPDATE
    apiCallToGetRecentUpdate = async () => {
        this.setState({
            fetchingRecentUpdate: true
        });
        
        let jsonResponse = {};
        if(this.state.assistance_type == "Online Demonstration" || this.state.assistance_type == "Onsite Assistance")
        {
            let demo_type = "online";
            if(this.state.assistance_type == "Onsite Assistance")
            {
                demo_type = "offline";
            }
            let requestData = {"page_index":this.state.page_index,"limit":this.state.limit,"demo_type":demo_type,"institute_id":config.institute_id}
            jsonResponse = await HomeApiCall.makeApiCall(
                'getClientDemoListForSummaryPage',
                requestData,
                '/api/dailyUpdates/dailyUpdate.php'
            );
        }else{
            let requestData = 
            {"page_index":this.state.page_index,"limit":this.state.limit,"module_name":this.state.module_name,"assistance_type":this.state.assistance_type,"institute_id":config.institute_id}

            jsonResponse = await HomeApiCall.makeApiCall(
                'getAssistanceTypeUpdatesListForSummaryPage',
                requestData,
                '/api/dailyUpdates/dailyUpdate.php'
            );
        }
        
        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetRecentUpdate();
            }, 1000);
        }else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                
                this.setState({
                    fetchingRecentUpdate: false,
                    RecentUpdateList:apiResult,
                    totalItemsCount:jsonResponse.APIResult.totalCount,
                });
            }
        }
    }

    //METHOD TO SET OFFSET OF RECENT UPDATE
    setRecentUpdatesOffset = (e) => {
        this.setState({
            limit: e.target.value,           
            offset: 0,
            page_index:1,
            activePage: 1,
            RecentUpdateList:[],
            module_name:[],
        }, () => this.apiCallToGetRecentUpdate()
        );
    }

    //METHOD TO GET RECENT UPDATE 
    getRecentUpdates = (e) => {
      
        this.setState({
            assistance_type: e.target.id,           
            offset: 0,
            page_index:1,
            activePage: 1,
            RecentUpdateList:[],
            module_name:[],
            filterDisplay:false,
        }, () => this.apiCallToGetRecentUpdate()
        );
    }

    //METHOD TO CLOSE RECENT UPDATES MODEL
    closeRecentUpdateModel = ()=>{
        
        this.setState({
            limit: 10,           
            offset: 0,
            page_index:1,
            activePage: 1,
            RecentUpdateList:[],
            showRecentUpdate:false,
            module_name:[],
            filterDisplay:false,
        }
        );
    }

    setModuleName = (e) =>{
        let selectedModuleName = e.target.value;
        let moduleNameArray = this.state.module_name;
        if(moduleNameArray.includes(selectedModuleName))
        {
            moduleNameArray = moduleNameArray.filter(module_name => module_name != selectedModuleName)
        }else{
            moduleNameArray.push(selectedModuleName);
        }
        this.setState({
            module_name: moduleNameArray,
        })
    }

    updatePaginationCount = (pageNumber) => {
        this.setState({
            offset: (pageNumber - 1) * this.state.limit,
            page_index:pageNumber,
            activePage: pageNumber,
        

        },()=>this.apiCallToGetRecentUpdate()           
        )

    }

    //METHOD TO CALL ON APPLY OF FILTER
    filterApiCall = () =>{
        let moduleNameArray = this.state.module_name;
        if(moduleNameArray.length == 0)
        {
            this.setState({
                moduleWaring:"Please select at least one module."
            })
        }else{
            this.setState({
                offset: 0,
                page_index:1,
                activePage: 1,
            },()=> this.apiCallToGetRecentUpdate())
        }
    }

    //CLEAR FILTER
    clearFilter = () =>{
        this.setState({
            offset: 0,
            page_index:1,
            activePage: 1,
            module_name:[],
            filterDisplay:false,
        },()=> this.apiCallToGetRecentUpdate())
    }
    // METHOD TO FOMRAT DATE
    formatDate = (d) =>{
        var date = new Date(d);

        if (isNaN(date.getTime())) {
            return "";
        }else{  
            var month = new Array();
            month[0] = "January";
            month[1] = "February";
            month[2] = "March";
            month[3] = "April";
            month[4] = "May";
            month[5] = "June";
            month[6] = "July";
            month[7] = "August";
            month[8] = "September";
            month[9] = "October";
            month[10] = "November";
            month[11] = "December";

            let day = date.getDate();
            
            if(day < 10) {
                day = "0"+day;
            }
            return day  + " " +month[date.getMonth()] + ", " + date.getFullYear();
        }       
    }

    returnRecentUpdateModel = () => {
        return(
            <div className={this.state.showRecentUpdate ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered modal-xl" style={{maxWidth:"90%"}}>
                    <div className="modal-content RecentUpdateModel-content">    
                        <div className="modal-header alert-header RecentUpdateHeader">
                            <ul className="nav nav-pills nav-fill" id="profile-view-tabs" role="tablist">
                                <li className="nav-item" style={{ fontSize: 13 }}>
                                    <a className={this.state.assistance_type=="Daily Updates"? "nav-link updatesTabs active":"nav-link updatesTabs"}  data-toggle="list" href="#Daily Updates" role="tab" id = "Daily Updates" onClick = {(e)=> this.getRecentUpdates(e)}>Recent Updates</a>
                                </li>
                                {/* <li className="nav-item" style={{ fontSize: 13 }}>
                                    <a className={this.state.assistance_type=="Helpdesk Assistance"? "nav-link updatesTabs active":"nav-link updatesTabs"}  data-toggle="list" href="#Helpdesk Assistance" role="tab" id = "Helpdesk Assistance" onClick = {(e)=> this.getRecentUpdates(e)}>Helpdesk Assistance</a>
                                </li>
                                <li className="nav-item" style={{ fontSize: 13 }}>
                                    <a className={this.state.assistance_type=="Telephonic Assistance"? "nav-link updatesTabs active":"nav-link updatesTabs"}  data-toggle="list" href="#Telephonic Assistance" role="tab" id = "Telephonic Assistance" onClick = {(e)=> this.getRecentUpdates(e)}>Telephonic Assistance</a>
                                </li>
                                <li className="nav-item" style={{ fontSize: 13 }}>
                                    <a className={this.state.assistance_type=="Email Assistance"? "nav-link updatesTabs active":"nav-link updatesTabs"}  data-toggle="list" href="#Email Assistance" role="tab" id = "Email Assistance" onClick = {(e)=> this.getRecentUpdates(e)}>Email Assistance</a>
                                </li>
                                <li className="nav-item" style={{ fontSize: 13 }}>
                                    <a className={this.state.assistance_type=="Online Demonstration"? "nav-link updatesTabs active":"nav-link updatesTabs"}  data-toggle="list" href="#Online Demonstration" role="tab" id = "Online Demonstration" onClick = {(e)=> this.getRecentUpdates(e)}>Online Demonstration</a>
                                </li>
                                <li className="nav-item" style={{ fontSize: 13 }}>
                                    <a className={this.state.assistance_type=="Onsite Assistance"? "nav-link updatesTabs active":"nav-link updatesTabs"}  data-toggle="list" href="#Onsite Assistance" role="tab" id = "Onsite Assistance" onClick = {(e)=> this.getRecentUpdates(e)}>Onsite Assistance</a>
                                </li> */}
                            </ul>
                            {/* <p style={{ fontSize: 13 }}>Please press <span style={{ fontWeight: 'bold' }}>escape</span> to close the recent updates.</p> */}
                            <FontAwesomeIcon title='Please press escape to close the recent updates' icon={['fas', 'times']} style={{ cursor: 'pointer' }} size="lg" color="#000000" onClick={() => this.closeRecentUpdateModel()}/>
                        </div>           
                        <div className="modal-body RecentUpdateModel-body">
                        {/* <p style={{ fontSize: 13, fontWeight: 'bold' }}>Note: Please press 'Escape' key to close the recent updates.</p> */}
                            <div className="mt-2 mb-3 reportsActionButtonsContainer"  >
                                <div style={{display:'flex',alignItems:'center'}}>
                                    <div className="perPageSelectContainer ">
                                        Show
                                        <select className="ml-2 mr-2" onChange={(e) => this.setRecentUpdatesOffset(e)}>
                                            <option value={10} selected={this.state.limit == 10}>10</option>
                                            <option value={25} selected={this.state.limit == 25}>25</option>
                                            <option value={40} selected={this.state.limit == 40}>40</option>
                                            <option value={100} selected={this.state.limit == 100}>100</option>
                                            <option value={250} selected={this.state.limit == 250}>250</option>
                                        </select>
                                        entries
                                    </div>
                                    {
                                        (this.state.assistance_type == "Helpdesk Assistance" || this.state.assistance_type == "Daily Updates") && 
                                        <div className="row ml-2" >
                                            <button type="button" style={{ backgroundColor: '#0465ac' }} onClick={() => this.setState({ filterDisplay: !this.state.filterDisplay })} className="btn primary-button filterButton">
                                                <FontAwesomeIcon icon={['fas', 'filter']}  className="mr-3" style={{ cursor: "pointer" }} />
                                                Filter
                                            </button>
                                        </div>
                                    }
                                </div>
                                <div id="reportsExportContainer">
                                    <button
                                        type="button"
                                        className="btn outline-button text-capitalize filterButton"
                                        onClick={(e) => this.exportToexelfunction()}
                                        style={{ backgroundColor: 'white' }}
                                    >
                                        <FontAwesomeIcon
                                            icon={["fas", "file-export"]}
                                            size="md"
                                            className="mr-2 text-capitalize"
                                            style={{ cursor: "pointer" }}
                                        />
                                        Export
                                    </button>
                                    <div style={{ display: 'none' }}>
                                        <ReactHTMLTableToExcel
                                            id="export"
                                            className="btn outline-button waves-effect text-capitalize"
                                            table="recentUpdate"
                                            filename="Recent_Updates"
                                            sheet="tablexls"
                                            buttonText="Export to Excel "
                                        >
                                        </ReactHTMLTableToExcel>
                                    </div>                                
                                </div>                            
                            </div>
                            <div className="filter-container col-md-12 jumbotron" style={{ display: this.state.filterDisplay ? 'block' : 'none',padding:10 }}>
                                <div className="filter-values col-md-12 ">
                                    <label style={{fontWeight:'bold'}}>Select Module</label>&nbsp;<span style={{color:"red"}}>*</span>
                                    <div style={{display:'flex'}}  >                                       
                                        <div className="col-md-4 col-lg-4 col-sm-4"  >
                                            <input type="checkbox" className="modules" value="Outcome" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Outcome <br/>
                                            <input type="checkbox" className="modules" value="Academic Planning" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Academic Planning <br/>
                                            <input type="checkbox" className="modules" value="Online Feedback" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Online Feedback <br/>
                                            <input type="checkbox" className="modules" value="Online Exam" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Online Exam <br/>
                                            <input type="checkbox" className="modules" value="Result Analysis" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Result Analysis <br/>
                                            <input type="checkbox" className="modules" value="Rubrics" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Rubrics <br/>
                                            <input type="checkbox" className="modules" value="Assignment" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Assignment <br/>
                                            <input type="checkbox" className="modules" value="IQAC Reports" onChange= {(e)=>this.setModuleName(e)} />&nbsp;IQAC Reports <br/>
                                            <input type="checkbox" className="modules" value="Alumni" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Alumni <br/>
                                            <input type="checkbox" className="modules" value="Student Details" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Student Details <br/>
                                            <input type="checkbox" className="modules" value="Event" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Event <br/>
                                            <input type="checkbox" className="modules" value="LMS" onChange= {(e)=>this.setModuleName(e)} />&nbsp;LMS <br/>
                                        </div>
                                        <div className="col-md-4 col-lg-4 col-sm-4" >
                                            <input type="checkbox" className="modules" value="LMS" onChange= {(e)=>this.setModuleName(e)} />&nbsp;LMS <br/>
                                            <input type="checkbox" className="modules" value="Online Grievance" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Online Grievance <br/>
                                            <input type="checkbox" className="modules" value="Leaderboard" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Leaderboard <br/>
                                            <input type="checkbox" className="modules" value="Notice Board" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Notice Board <br/>
                                            <input type="checkbox" className="modules" value="Mentoring" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Mentoring <br/>
                                            <input type="checkbox" className="modules" value="Training and Placement" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Training and Placement <br/>
                                            <input type="checkbox" className="modules" value="Library" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Library <br/>
                                            <input type="checkbox" className="modules" value="Leave Management" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Leave Management <br/>
                                            <input type="checkbox" className="modules" value="Transport" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Transport <br/>
                                            <input type="checkbox" className="modules" value="Inventory" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Inventory <br/>
                                            <input type="checkbox" className="modules" value="Fees" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Fees <br/>
                                            <input type="checkbox" className="modules" value="Payroll" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Payroll <br/>
                                            <input type="checkbox" className="modules" value="Certificate" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Certificate <br/>
                                        </div>
                                        <div className="col-md-4 col-lg-4 col-sm-4"  >
                                            <input type="checkbox" className="modules" value="Payroll" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Payroll <br/>
                                            <input type="checkbox" className="modules" value="Certificate" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Certificate <br/>
                                            <input type="checkbox" className="modules" value="SMS Panel" onChange= {(e)=>this.setModuleName(e)} />&nbsp;SMS Panel <br/>
                                            <input type="checkbox" className="modules" value="Forms" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Forms <br/>
                                            <input type="checkbox" className="modules" value="Student Performance" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Student Performance <br/>
                                            <input type="checkbox" className="modules" value="Faculty Profile" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Faculty Profile <br/>
                                            <input type="checkbox" className="modules" value="Help Desk" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Help Desk <br/>
                                            <input type="checkbox" className="modules" value="Personalise" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Personalise <br/>
                                            <input type="checkbox" className="modules" value="Accounting" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Accounting <br/>
                                            <input type="checkbox" className="modules" value="Employee Registration" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Employee Registration <br/>
                                            <input type="checkbox" className="modules" value="Committee and Meetings" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Committee and Meetings <br/>
                                            <input type="checkbox" className="modules" value="Inward and Outward" onChange= {(e)=>this.setModuleName(e)} />&nbsp;Inward and Outward <br/>
                                        </div>
                                      
                                    </div>
                                
                                    <span style={{display: this.state.moduleWaring.length > 0 ? 'block' : 'none', color: 'red'}}>{this.state.moduleWaring}</span>
                                    
                                    <div className="filter-buttons  col-md-12">
                                        <button className="btn outline-button pull-right text-capitalize" onClick={this.clearFilter}>Clear</button>

                                        <button className="btn primary-button pull-right text-white text-capitalize" style={{ backgroundColor: "#0465ac" }} onClick={this.filterApiCall}>Apply</button>
                                    </div>
                                </div>
                            </div>
                            <div className="LatestUpdateContainer">
                                <div className="LatestUpdate">
                                    <table className="table table-bordered" id = "recentUpdate">
                                        <thead>
                                        {
                                            this.state.assistance_type == "Daily Updates" ?
                                            <tr>                                                
                                                <th style={{ padding: 5 }}>Sr. No.</th>
                                                <th style={{ padding: 5 }}>Date</th>
                                                <th style={{ padding: 5 }}>Module</th>
                                                <th style={{ padding: 5 }}>Description</th>
                                             
                                            </tr>
                                            :(this.state.assistance_type == "Helpdesk Assistance" || this.state.assistance_type == "Telephonic Assistance" || this.state.assistance_type == "Email Assistance") ?
                                            <tr>                                                
                                                <th style={{ padding: 5 }}>Sr. No.</th>
                                                <th style={{ padding: 5 }}>Date</th>
                                                <th style={{ padding: 5 }}>Module</th>
                                                <th style={{ padding: 5 }}>Ref. ID</th>
                                                <th style={{ padding: 5 }}>Name</th>
                                                <th style={{ padding: 5 }}>Subject</th>
                                            </tr>
                                            :(this.state.assistance_type == "Online Demonstration" || this.state.assistance_type == "Onsite Assistance") &&
                                            <tr>                                                
                                                <th style={{ padding: 5 }}>Sr. No.</th>
                                                <th style={{ padding: 5 }}>Date</th>
                                                <th style={{ padding: 5 }}>Module</th>
                                                <th style={{ padding: 5 }}>Duration</th>
                                                <th style={{ padding: 5 }}>Subject</th>
                                            </tr>
                                            
                                        }
                                            
                                            
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.fetchingRecentUpdate ?
                                                    <ButtonLoader />
                                                :
                                                    this.state.RecentUpdateList.length > 0 ?
                                                        this.state.RecentUpdateList.map((update, index) => {                                                        
                                                            return(
                                                                
                                                                    this.state.assistance_type == "Daily Updates" ?
                                                                        <tr key={update.uniqueId}>
                                                                            <td style={{ padding: 5 }}>{this.state.offset + index + 1}.</td>
                                                                            <td style={{ padding: 5 }}>{moment(update.date).format('DD MMM, YYYY')}</td>
                                                                            <td style={{ padding: 5 }}>{update.moduleName}</td>
                                                                            <td style={{ padding: 5 }}>{ReactHtmlParser(update.description)}</td>
                                                                        </tr>
                                                                    :(this.state.assistance_type == "Helpdesk Assistance" || this.state.assistance_type == "Telephonic Assistance" || this.state.assistance_type == "Email Assistance") ?
                                                                        <tr key={update.uniqueId}>
                                                                            <td style={{ padding: 5 }}>{this.state.offset + index + 1}.</td>
                                                                            <td style={{ padding: 5 }}>{this.formatDate(update.date)}</td>
                                                                            <td style={{ padding: 5 }}>{update.moduleName}</td>
                                                                            <td style={{ padding: 5 }}>{update.uniqueId}</td>
                                                                            <td style={{ padding: 5 }}>{update.name}</td>
                                                                            <td style={{ padding: 5 }}>{ReactHtmlParser(this.state.assistance_type == "Email Assistance" ? update.query : update.description)}</td>
                                                                        </tr>
                                                                        :(this.state.assistance_type == "Online Demonstration" || this.state.assistance_type == "Onsite Assistance") &&
                                                                        <tr>                                                
                                                                            <td style={{ padding: 5 }}>{this.state.offset + index + 1}.</td>
                                                                            <td style={{ padding: 5 }}>{this.formatDate(update.date)}</td>
                                                                            <td style={{ padding: 5 }}>{update.moduleName}</td>
                                                                            <td style={{ padding: 5 }}>{update.duration}</td>
                                                                            <td style={{ padding: 5 }}>{update.query}</td>
                                                                        </tr>
                                                                   
                                                                    
                                                                
                                                            );
                                                        })
                                                    :
                                                        <tr>
                                                            <td colSpan={this.state.assistance_type == "Daily Updates" ? 4 : (this.state.assistance_type == "Helpdesk Assistance" || this.state.assistance_type == "Telephonic Assistance" || this.state.assistance_type == "Email Assistance") ? 6:7} style={{ padding: 5 }}>No {this.state.assistance_type.toLocaleLowerCase()} details found.</td>
                                                        </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="text-center">
                                {
                                    (this.state.RecentUpdateList.length != 0) &&
                                    <div id="paginationContainer">
                                        <Pagination
                                            activePage={this.state.activePage}
                                            itemsCountPerPage={this.state.limit}
                                            totalItemsCount={this.state.totalItemsCount}
                                            pageRangeDisplayed={3}
                                            onChange={(num) => this.updatePaginationCount(num)}
                                        />
                                        
                                    </div>
                                }
                                </div>
                                <br></br>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    //FUNCTION FOR GET  ADD FILE
    exportToexelfunction = () => {
        document.getElementById("export").click();
    };

    render() {
        return (
            <>
                {
                    this.state.fetchingAssistanceDetails ?
                        <ButtonLoader />
                    :
                        <div style= {{cursor:'pointer'}} onClick={() => this.setState({showRecentUpdate:true},()=> this.apiCallToGetRecentUpdate())}>
                            <p style={{ fontWeight: 14, color: '#2979FF', fontWeight: 'bold', }} >Recent Updates</p>
                            <div className="updatesContainer">
                                <div className="helpdeskCount">
                                    <p style={{ color: '#4A4B57', fontSize: 14 }}>
                                        <FontAwesomeIcon icon={['fas', 'desktop']} style={{ marginRight: 5 }} color="#5A5B6A" />
                                        Helpdesk Assistance
                                    </p>
                                    <p className="helpdesk-count">{this.state.helpDeskAssistance}</p>
                                </div>
                                <div className="telephonicCount">
                                    <p style={{ color: '#4A4B57', fontSize: 14 }}>
                                        <FontAwesomeIcon icon={['fas', 'phone-alt']} style={{ marginRight: 5 }} color="#5A5B6A" />
                                        Telephonic Assistance
                                    </p>
                                    <p className="telephonic-count">{this.state.telephonicAssistance}</p>
                                </div>
                                <div className="emailCount">
                                    <p style={{ color: '#4A4B57', fontSize: 14 }}>
                                        <FontAwesomeIcon icon={['fas', 'envelope']} style={{ marginRight: 5 }} color="#5A5B6A" />
                                        Email Assistance
                                    </p>
                                    <p className="email-count">{this.state.emailAssistance}</p>
                                </div>
                                <div className="onlineDemo">
                                    <p style={{ color: '#4A4B57', fontSize: 14 }}>
                                        <FontAwesomeIcon icon={['fas', 'video']} style={{ marginRight: 5 }} color="#5A5B6A" />
                                        Online Demonstration
                                    </p>
                                    <p className="demo-count">{this.state.onlineDemo}</p>
                                </div>
                                <div className="onlineAssistance">
                                    <p style={{ color: '#4A4B57', fontSize: 14 }}>
                                        <FontAwesomeIcon icon={['fas', 'user-check']} style={{ marginRight: 5 }} color="#5A5B6A" />
                                        Onsite Assistance
                                    </p>
                                    <p className="onsite-count">{this.state.onlineAssistance}</p>
                                </div>
                            </div>
                        </div>
                }
                
                {
                    this.returnRecentUpdateModel()
                }
            </>
        );
    }
}

export default LatestUpdates;